import { render, staticRenderFns } from "./MappingsEdit.vue?vue&type=template&id=d24f2db0&"
import script from "./MappingsEdit.vue?vue&type=script&lang=js&"
export * from "./MappingsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MappingsEdit.vue"
export default component.exports